import { useMutation } from '@tanstack/react-query'

import { useInvalidateOnboardingChecklistQuery } from '@/hooks/useInvalidateOnboardingChecklistQuery'
import { useInvalidatePanelQueries } from '@/hooks/useInvalidatePanelQueries'
import useNotyf from '@/hooks/useNotyf'
import { useShowGenericServerError } from '@/hooks/useShowGenericServerError'
import addPanelService from '@/lib/services/addPanelService'
import panelService from '@/lib/services/panelService'

interface MutationVariables {
  toCompany: IRI
}

export function useCreatePanelWithoutAgreementsMutation() {
  const notyf = useNotyf()
  const invalidatePanelQueries = useInvalidatePanelQueries()
  const invalidateOnboardingChecklistQuery =
    useInvalidateOnboardingChecklistQuery()
  const showGenericServerError = useShowGenericServerError()

  return useMutation({
    mutationFn: ({ toCompany }: MutationVariables) =>
      panelService.createPanelWithoutAgreements({ toCompany }),
    onSuccess: async () => {
      await invalidatePanelQueries()
      await invalidateOnboardingChecklistQuery()
      notyf.success('Invite successfully sent')
    },
    onError: (error) => {
      if (addPanelService.isPanelRelatedError(error)) {
        notyf.error(error.response.data.errors.panel)
        return
      }

      showGenericServerError()
    },
  })
}
